import { Mitarbeiter_RotationsplanVorlageDauerEinheit } from '@/gql/graphql';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

const DAUER_EINHEITEN = [
  Mitarbeiter_RotationsplanVorlageDauerEinheit.Tage,
  Mitarbeiter_RotationsplanVorlageDauerEinheit.Wochen,
  Mitarbeiter_RotationsplanVorlageDauerEinheit.Monate,
];

export function DauerEinheitSelect({
  value,
  handleChange,
}: {
  value: Mitarbeiter_RotationsplanVorlageDauerEinheit;
  handleChange: (value: Mitarbeiter_RotationsplanVorlageDauerEinheit) => void;
}) {
  const { t } = useTranslation();

  return (
    <Select
      value={value}
      onValueChange={(einheit) =>
        handleChange(einheit as Mitarbeiter_RotationsplanVorlageDauerEinheit)
      }>
      <SelectTrigger
        aria-label={t(
          'domain.mitarbeiter.rotationsplan.vorlagen.createStation.fields.dauer.einheitLabel',
        )}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent
        mobileTitle={t(
          'domain.mitarbeiter.rotationsplan.vorlagen.createStation.fields.dauer.einheitLabel',
        )}>
        {DAUER_EINHEITEN.map((einheit) => (
          <SelectItem key={einheit} value={einheit}>
            {t(
              `domain.mitarbeiter.rotationsplan.vorlagen.createStation.fields.dauer.einheit.${einheit}`,
            )}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
